/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 *
 * @export
 */
export const FlightBookingHandoffStatus = {
    Bookable: 'bookable',
    MatchedNonbookable: 'matched_nonbookable',
    Similar: 'similar',
    Unavailable: 'unavailable',
    ExternalBookingRequired: 'external_booking_required',
    Expired: 'expired'
} as const;
export type FlightBookingHandoffStatus = typeof FlightBookingHandoffStatus[keyof typeof FlightBookingHandoffStatus];


export function instanceOfFlightBookingHandoffStatus(value: any): boolean {
    for (const key in FlightBookingHandoffStatus) {
        if (Object.prototype.hasOwnProperty.call(FlightBookingHandoffStatus, key)) {
            if (FlightBookingHandoffStatus[key as keyof typeof FlightBookingHandoffStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FlightBookingHandoffStatusFromJSON(json: any): FlightBookingHandoffStatus {
    return FlightBookingHandoffStatusFromJSONTyped(json, false);
}

export function FlightBookingHandoffStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightBookingHandoffStatus {
    return json as FlightBookingHandoffStatus;
}

export function FlightBookingHandoffStatusToJSON(value?: FlightBookingHandoffStatus | null): any {
    return value as any;
}

export function FlightBookingHandoffStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): FlightBookingHandoffStatus {
    return value as FlightBookingHandoffStatus;
}
